"use client"

import classNames from "classnames"
import { ReactNode, useId } from "react"
import { Placement } from "react-bootstrap/esm/types"
import { BoxArrowUpRight, QuestionCircleFill } from "react-bootstrap-icons"

import { OverlayTrigger, Tooltip } from "./wrapped"

import styles from "@/styles/util.module.scss"


type FtmSchemaLinkProps = {
  name: string
}

export function FtmSchemaLink({ name }: FtmSchemaLinkProps) {
  return (
    <OverlayTrigger placement="top" overlay={<Tooltip id={`ftm-schema-${name}`}><code className={styles.tooltipCode}>{name}</code> on FtM</Tooltip>}>
      <code><a href={`https://followthemoney.tech/explorer/schemata/${name}/`} aria-label={`${name} on FtM`}>
        {name}
        <BoxArrowUpRight className={styles.smallExternalIcon} />
      </a></code>
    </OverlayTrigger>
  )
}

type HelpLinkProps = {
  href?: string
  size?: number
  children?: ReactNode
  placement?: Placement
}

export function HelpLink({ href, size = 10, children, placement = 'top' }: HelpLinkProps) {
  const tooltipId = useId();
  const icon = <sup><QuestionCircleFill size={size} /></sup>;
  // Without an href the icon is a tooltip anchor only, not a link.
  const link = href
    ? <a href={href} className={classNames("d-print-none", styles.helpLink)}>{icon}</a>
    : <span className={classNames("d-print-none", styles.helpLink)}>{icon}</span>;
  return (
    children
      ? <OverlayTrigger placement={placement} overlay={<Tooltip id={tooltipId} >{children}</Tooltip>} >
        <span>{link}</span>
      </OverlayTrigger>
      : link
  )
}



type ExplainProps = {
  tooltip: string
  placement?: string
}

export function Explain({ children, tooltip, placement = 'right' }: React.PropsWithChildren<ExplainProps>) {
  return (
    <OverlayTrigger
      placement={placement as Placement}
      delay={{ show: 10, hide: 50 }}
      overlay={
        <Tooltip id="explain-tooltip">
          <div className={styles.explainContent}>{tooltip}</div>
        </Tooltip>
      }
    >
      <span className={styles.explainAnchor}>{children}</span>
    </OverlayTrigger>
  )
}

